<template>
  <Content title="Privados">
    <Spinner v-if="loading.view"></Spinner>
    <template v-else>
      <Card title="Filtros" icon="fa fa-filter">
        <div class="row">
          <div class="col-12 col-md-3 col-lg-2">
            <div class="form-group">
              <label for="" class="form-label">
                Agencia:
              </label>
              <InputSelect v-model="form.agencia" :options="agenciasFiltro" label="nombre" :disabled="hayEditables"></InputSelect>
            </div>
          </div>
          <div class="col-12 col-md-3 col-lg-2">
            <div class="form-group">
              <label for="" class="form-label">
                Fecha Llegada:
              </label>
              <InputDatepicker v-model="form.fechaLlegada" :editable="false" input-class="form-control form-control-sm" :disabled="hayEditables"></InputDatepicker>
            </div>
          </div>
          <div class="col-12 col-md-3 col-lg-2">
            <div class="form-group">
              <label for="" class="form-label">
                Pasajero:
              </label>
              <InputText v-model="form.pasajero" input-class="form-control form-control-sm" :disabled="hayEditables"></InputText>
            </div>
          </div>
          <div class="col-12 col-md-3 col-lg-2">
            <div class="form-group">
              <label for="" class="form-label">
                Código:
              </label>
              <InputText v-model="form.codigo" input-class="form-control form-control-sm" :disabled="hayEditables"></InputText>
            </div>
          </div>
        </div>
      </Card>
      <Card title="Privados" bodyClass="p-0">
        <template #toolbar>
          <Button variant="outline-secondary" class="btn-sm" :disabled="loading.reporte || !paginacion.total || hayEditables" @click="onPrint">
            {{ loading.reporte ? "Preparando..." : "Imprimir" }}
          </Button>
        </template>
        <PrivadosTable :rows="list" @store="onStore"></PrivadosTable>
        <BPagination
          v-if="paginacion.total > paginacion.porPagina"
          :value="paginacion.pagina"
          :total-rows="paginacion.total"
          :per-page="paginacion.porPagina"
          :disabled="loading.privados || hayEditables"
          first-number
          last-number
          :limit="6"
          align="center"
          class="mt-5"
          @input="onCambiarPagina"
        ></BPagination>
      </Card>
      <PrivadoItinerarioModal v-if="containers.showModalPrivadoItinerario" :modal-item="containers.modalItem" @hide="containers.showModalPrivadoItinerario = false"></PrivadoItinerarioModal>
      <PrivadoLiquidarModal v-if="containers.showModalPrivadoLiquidar" :modal-item="containers.modalItem" @hide="containers.showModalPrivadoLiquidar = false"></PrivadoLiquidarModal>
    </template>
  </Content>
</template>

<script>
import { BPagination } from "bootstrap-vue";
import { mapGetters, mapState } from "vuex";

import Button from "../../shared/components/Button.vue";
import Content from "../../shared/components/Content.vue";
import Card from "../../shared/components/Card.vue";
import InputText from "../../shared/components/InputText.vue";
import InputSelect from "../../shared/components/InputSelect.vue";
import InputDatepicker from "../../shared/components/InputDatepicker.vue";
import PrivadoItinerarioModal from "../components/PrivadoItinerarioModal.vue";
import PrivadoLiquidarModal from "../components/PrivadoLiquidarModal.vue";
import PrivadosTable from "../components/PrivadosTable.vue";
import Spinner from "../../shared/components/Spinner.vue";
import { debounce } from "../../shared/helpers";
import pdfPrivados from "../../../pdfs/pdfPrivados";

export default {
  components: { Spinner, PrivadosTable, PrivadoLiquidarModal, PrivadoItinerarioModal, InputDatepicker, InputSelect, InputText, Card, Content, Button, BPagination },
  data() {
    return {
      loading: {
        view: true,
        privados: false,
        reporte: false,
      },
      form: {
        agencia: null,
        fechaLlegada: "",
        pasajero: "",
        codigo: "",
      },
      paginacion: {
        pagina: 1,
        porPagina: 50,
        total: 0,
        ultimaPagina: 0,
      },
      inicializado: false,
      solicitudPrivados: 0,
      containers: {
        modalItem: null,
        showModalPrivadoLiquidar: false,
        showModalPrivadoItinerario: false,
      },
    };
  },
  computed: {
    ...mapState("privados", ["list", "agenciasFiltro"]),
    ...mapGetters("privados", ["hayEditables"]),
  },
  watch: {
    form: {
      deep: true,
      handler() {
        if (!this.inicializado) return;

        this.solicitudPrivados += 1;
        this.onCambiarFiltros();
      },
    },
  },
  async created() {
    try {
      await this.cargarFiltros();
      await this.cargarPrivados();
    } catch (error) {
      console.error(error?.response || error);
    } finally {
      this.inicializado = true;
      this.loading.view = false;
    }
  },
  mounted() {
    const vm = this;
    vm.$root.$on("show:privado:liquidacion", (item) => {
      vm.containers.modalItem = item;
      vm.containers.showModalPrivadoLiquidar = true;
    });
    vm.$root.$on("show:privado:itinerario", (item) => {
      vm.containers.modalItem = item;
      vm.containers.showModalPrivadoItinerario = true;
    });
  },
  methods: {
    async cargarFiltros() {
      const response = await this.axios.get("/privados/filtros");
      this.$store.commit("privados/loadContainers", response.data.content);
    },
    parametrosFiltros(form = this.form) {
      const parametros = {};

      if (form.agencia?.idAgencia) {
        parametros.idAgencia = form.agencia.idAgencia;
      }

      if (form.fechaLlegada) {
        parametros.fechaLlegada = form.fechaLlegada;
      }

      const pasajero = String(form.pasajero || "").trim();
      if (pasajero) {
        parametros.pasajero = pasajero;
      }

      const codigo = String(form.codigo || "").trim();
      if (codigo) {
        parametros.codigo = codigo;
      }

      return parametros;
    },
    parametrosPrivados() {
      return {
        ...this.parametrosFiltros(),
        pagina: this.paginacion.pagina,
        porPagina: this.paginacion.porPagina,
      };
    },
    prepararPrivado(item) {
      return {
        ...item,
        isNew: false,
        isEdit: false,
        tempAgencia: null,
        tempDocVenta: null,
        tempFechaLlegada: "",
        tempFechaSalida: "",
        tempIdioma: "",
        tempPAX: "",
        tempCHD: "",
        tempNroDocVenta: "",
        tempPasajero: "",
      };
    },
    async cargarPrivados() {
      const solicitud = ++this.solicitudPrivados;
      this.loading.privados = true;

      try {
        const response = await this.axios.get("/privados", {
          params: this.parametrosPrivados(),
        });

        if (solicitud !== this.solicitudPrivados) return;

        const privados = response.data.content.privados.map((item) => this.prepararPrivado(item));
        const paginacion = response.data.paginacion;

        if (!privados.length && this.paginacion.pagina > 1 && paginacion.ultimaPagina < this.paginacion.pagina) {
          this.paginacion.pagina = Math.max(1, paginacion.ultimaPagina);
          await this.cargarPrivados();
          return;
        }

        this.$store.commit("privados/updateList", privados);
        this.paginacion = paginacion;
      } catch (error) {
        if (solicitud === this.solicitudPrivados) {
          console.error(error?.response || error);
        }
      } finally {
        if (solicitud === this.solicitudPrivados) {
          this.loading.privados = false;
        }
      }
    },
    onCambiarFiltros: debounce(function() {
      if (this.hayEditables) return;

      this.paginacion.pagina = 1;
      this.cargarPrivados();
    }, 400),
    onCambiarPagina(pagina) {
      if (pagina === this.paginacion.pagina || this.hayEditables) return;

      this.paginacion.pagina = pagina;
      this.cargarPrivados();
    },
    async onStore() {
      await Promise.all([this.cargarFiltros(), this.cargarPrivados()]);
    },
    async onPrint() {
      if (this.loading.reporte || !this.paginacion.total || this.hayEditables) return;

      const form = {
        agencia: this.form.agencia,
        fechaLlegada: this.form.fechaLlegada,
        pasajero: this.form.pasajero,
        codigo: this.form.codigo,
      };

      this.loading.reporte = true;

      try {
        const response = await this.axios.get("/privados/reporte", {
          params: this.parametrosFiltros(form),
        });
        const privadosReporte = response.data.content.privados;

        if (!privadosReporte.length) {
          this.$toast.fire("", "No hay privados para imprimir", "warning");
          return;
        }

        const privados = privadosReporte.map((item) => ({
          ...item,
          fechaLlegada: this.$options.filters.date(item.fechaLlegada),
          fechaSalida: this.$options.filters.date(item.fechaSalida),
        }));

        pdfPrivados({
          privados,
          agencia: form.agencia?.nombre || "",
          fechaLlegada: this.$options.filters.date(form.fechaLlegada),
          pasajero: form.pasajero,
          userMark: this.$store.state.user,
          dateMark: this.$dayjs().format("DD-MM-YY HH:mm"),
        });
      } catch (error) {
        console.error(error?.response || error);
        this.$toast.fire("", error?.response?.data?.message || "No fue posible preparar el reporte", "error");
      } finally {
        this.loading.reporte = false;
      }
    },
  },
};
</script>

<style></style>
